import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CbFormsModule } from '@app/shared/components/forms/forms.module';
import { CbLoadingSpinnerModule, CbSelectListModule } from 'cb-hub-lib';
import { CommonModule } from '@angular/common';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';
import { RevisionReportComponent } from './revision-report.component';

@NgModule({
    declarations: [
        RevisionReportComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatCardModule,
        MatCheckboxModule,
        InfiniteScrollDirective,
        CbLoadingSpinnerModule,
        CbFormsModule,
        CbSelectListModule
    ],
    exports: [
        RevisionReportComponent
    ]
})

export class RevisionReportModule { }
